import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7091/Crm";
	}
	connectCrmAgencyProvider(e, t) {
		let r = this.baseUrl + "/ConnectCrmAgencyProvider", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processConnectCrmAgencyProvider(e)));
	}
	processConnectCrmAgencyProvider(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 409 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 429 || e.status === 503 ? B("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	createCrmLead(e, t) {
		let r = this.baseUrl + "/CreateCrmLead", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateCrmLead(e)));
	}
	processCreateCrmLead(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	crmProviderWebhook(e, t, r, i, a) {
		let o = this.baseUrl + "/CrmProviderWebhook/{provider}";
		if (e == null) throw new globalThis.Error("The parameter 'provider' must be defined and cannot be null.");
		if (o = o.replace(/* @__PURE__ */ RegExp("\\{provider(?::[^}]+)?\\}", "gi"), encodeURIComponent(f(e))), o += "?", r === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (r !== void 0 && (o += "agencyId=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'organisationId' cannot be null.");
		i !== void 0 && (o += "organisationId=" + encodeURIComponent(f(i)) + "&"), o = o.replace(/[?&]$/, "");
		let s = JSON.stringify(t), c = {
			method: "POST",
			url: o,
			headers: { "Content-Type": "application/json" },
			data: s,
			signal: a
		};
		return this.transformOptions(c).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processCrmProviderWebhook(e)));
	}
	processCrmProviderWebhook(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 413 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	disconnectCrmAgencyProvider(e, t) {
		let r = this.baseUrl + "/DisconnectCrmAgencyProvider", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDisconnectCrmAgencyProvider(e)));
	}
	processDisconnectCrmAgencyProvider(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 409 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	exportCrmNetworkItemizedTransactions(e, t) {
		let r = this.baseUrl + "/ExportCrmNetworkItemizedTransactions", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "text/csv"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processExportCrmNetworkItemizedTransactions(e)));
	}
	processExportCrmNetworkItemizedTransactions(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmActiveListingsForAgency(e, t) {
		let r = this.baseUrl + "/GetCrmActiveListingsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmActiveListingsForAgency(e)));
	}
	processGetCrmActiveListingsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmAgencyConnectionDetails(e, t) {
		let r = this.baseUrl + "/GetCrmAgencyConnectionDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmAgencyConnectionDetails(e)));
	}
	processGetCrmAgencyConnectionDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 409 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmAgencyListingsPermanentLinkModel(e, t) {
		let r = this.baseUrl + "/GetCrmAgencyListingsPermanentLinkModel";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmAgencyListingsPermanentLinkModel(e)));
	}
	processGetCrmAgencyListingsPermanentLinkModel(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmAgentDetails(e, t, r) {
		let i = this.baseUrl + "/GetCrmAgentDetails";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		i += "agentId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetCrmAgentDetails(e)));
	}
	processGetCrmAgentDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmContractCommissionDiscrepancies(e, t) {
		let r = this.baseUrl + "/GetCrmContractCommissionDiscrepancies";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmContractCommissionDiscrepancies(e)));
	}
	processGetCrmContractCommissionDiscrepancies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmCurrentPartnershipInformation(e, t, r, i) {
		let a = this.baseUrl + "/GetCrmCurrentPartnershipInformation";
		if (a += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (a += "agencyId=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'anniversaryDateToUse' cannot be null.");
		if (t !== void 0 && (a += "anniversaryDateToUse=" + encodeURIComponent(f(t)) + "&"), r === null) throw new globalThis.Error("The parameter 'previousYear' cannot be null.");
		r !== void 0 && (a += "previousYear=" + encodeURIComponent(f(r)) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processGetCrmCurrentPartnershipInformation(e)));
	}
	processGetCrmCurrentPartnershipInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmEntityNumbers(e, t) {
		let r = this.baseUrl + "/GetCrmEntityNumbers", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmEntityNumbers(e)));
	}
	processGetCrmEntityNumbers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmExecutiveKeyMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmExecutiveKeyMetrics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
		r += "month=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmExecutiveKeyMetrics(e)));
	}
	processGetCrmExecutiveKeyMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmExecutiveRunRateMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmExecutiveRunRateMetrics";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
		r += "month=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmExecutiveRunRateMetrics(e)));
	}
	processGetCrmExecutiveRunRateMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmLeaderboardStatisticsForEntity(e, t) {
		let r = this.baseUrl + "/GetCrmLeaderboardStatisticsForEntity", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmLeaderboardStatisticsForEntity(e)));
	}
	processGetCrmLeaderboardStatisticsForEntity(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmListingByCampaignId(e, t, r) {
		let i = this.baseUrl + "/GetCrmListingByCampaignId";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		i += "campaignId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetCrmListingByCampaignId(e)));
	}
	processGetCrmListingByCampaignId(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? B("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmListingDiscrepancies(e, t) {
		let r = this.baseUrl + "/GetCrmListingDiscrepancies";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmListingDiscrepancies(e)));
	}
	processGetCrmListingDiscrepancies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmNetworkPartnershipMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmNetworkPartnershipMetrics", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmNetworkPartnershipMetrics(e)));
	}
	processGetCrmNetworkPartnershipMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmNetworkStateMetrics(e, t) {
		let r = this.baseUrl + "/GetCrmNetworkStateMetrics", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmNetworkStateMetrics(e)));
	}
	processGetCrmNetworkStateMetrics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPartnershipInformation(e, t) {
		let r = this.baseUrl + "/GetCrmPartnershipInformation", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPartnershipInformation(e)));
	}
	processGetCrmPartnershipInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPublishedListingDetail(e, t, r) {
		let i = this.baseUrl + "/GetCrmPublishedListingDetail";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'listingId' must be defined and cannot be null.");
		i += "listingId=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetCrmPublishedListingDetail(e)));
	}
	processGetCrmPublishedListingDetail(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 404 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPublishedListingDetails(e, t) {
		let r = this.baseUrl + "/GetCrmPublishedListingDetails", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPublishedListingDetails(e)));
	}
	processGetCrmPublishedListingDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmPublishedListingsAgentsAndSuburbs(e, t) {
		let r = this.baseUrl + "/GetCrmPublishedListingsAgentsAndSuburbs";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmPublishedListingsAgentsAndSuburbs(e)));
	}
	processGetCrmPublishedListingsAgentsAndSuburbs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmStaffLeaderboardStatistics(e, t, r, i, a, o) {
		let s = this.baseUrl + "/GetCrmStaffLeaderboardStatistics";
		if (s += "?", e == null) throw new globalThis.Error("The parameter 'entityType' must be defined and cannot be null.");
		if (s += "entityType=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'timePeriod' must be defined and cannot be null.");
		if (s += "timePeriod=" + encodeURIComponent(f(t)) + "&", r == null) throw new globalThis.Error("The parameter 'contractDateToUse' must be defined and cannot be null.");
		if (s += "contractDateToUse=" + encodeURIComponent(f(r)) + "&", i === null) throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
		if (i !== void 0 && (s += "fromDate=" + encodeURIComponent(f(i)) + "&"), a === null) throw new globalThis.Error("The parameter 'toDateExclusive' cannot be null.");
		a !== void 0 && (s += "toDateExclusive=" + encodeURIComponent(f(a)) + "&"), s = s.replace(/[?&]$/, "");
		let c = {
			method: "GET",
			url: s,
			headers: { Accept: "application/json" },
			signal: o
		};
		return this.transformOptions(c).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(s, e, (e) => this.processGetCrmStaffLeaderboardStatistics(e)));
	}
	processGetCrmStaffLeaderboardStatistics(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmStatisticsForEntity(e, t) {
		let r = this.baseUrl + "/GetCrmStatisticsForEntity", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmStatisticsForEntity(e)));
	}
	processGetCrmStatisticsForEntity(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmSuburbs(e, t) {
		let r = this.baseUrl + "/GetCrmSuburbs", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmSuburbs(e)));
	}
	processGetCrmSuburbs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmTopPerformers(e) {
		let t = this.baseUrl + "/GetCrmTopPerformers", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetCrmTopPerformers(e)));
	}
	processGetCrmTopPerformers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCrmUpcomingSettlementsForAgency(e, t) {
		let r = this.baseUrl + "/GetCrmUpcomingSettlementsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCrmUpcomingSettlementsForAgency(e)));
	}
	processGetCrmUpcomingSettlementsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	setCrmListingPublishedToPortal(e, t) {
		let r = this.baseUrl + "/SetCrmListingPublishedToPortal", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetCrmListingPublishedToPortal(e)));
	}
	processSetCrmListingPublishedToPortal(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateCrmAgentDetails(e, t) {
		let r = this.baseUrl + "/UpdateCrmAgentDetails", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateCrmAgentDetails(e)));
	}
	processUpdateCrmAgentDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 401 ? B("No description", e.status, e.data, t) : e.status === 409 || e.status === 501 ? B("Payload of CrmResultMetadata", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : B("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Supported = "Supported", e.Unsupported = "Unsupported", e.PendingValidation = "PendingValidation", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.NotConnected = "NotConnected", e.Connected = "Connected", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.NotConnected = "NotConnected", e.Connected = "Connected", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e.Leased = "Leased", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.DatePushedToPortal = "DatePushedToPortal", e.SoldDate = "SoldDate", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.VirtualTour = "VirtualTour", e.VideoLink = "VideoLink", e.InteractiveFloorPlan = "InteractiveFloorPlan", e.MiniWeb = "MiniWeb", e.ExternalLink = "ExternalLink", e.Unknown = "Unknown", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Warning = "Warning", e.Error = "Error", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e.Leased = "Leased", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.IndividualOrTeam = "IndividualOrTeam", e.Agency = "Agency", e.Partnership = "Partnership", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e[e._0 = 0] = "_0", e[e._1 = 1] = "_1", e[e._2 = 2] = "_2", e[e._3 = 3] = "_3", e[e._4 = 4] = "_4", e[e._5 = 5] = "_5", e[e._6 = 6] = "_6", e[e._7 = 7] = "_7", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), z = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isCrmApiException = !0;
	static isCrmApiException(e) {
		return e.isCrmApiException === !0;
	}
};
function B(e, t, n, r, i) {
	throw i ?? new z(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var V = "crm";
function H(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var U = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), H(r);
}, W = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.crm || `${e}/crm`;
}, G = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = W(i), u = c, d = U(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = U(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, K = a({}), q = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = G(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(K.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, J = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.connectCrmAgencyProvider(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		connectCrmAgencyProvider: d,
		connectCrmAgencyProviderPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Y = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createCrmLead(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createCrmLead: d,
		createCrmLeadPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, X = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { provider: t, body: n, agencyId: r, organisationId: i } = e;
		return s.crmProviderWebhook(t, n, r, i);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		crmProviderWebhook: d,
		crmProviderWebhookPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Z = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.disconnectCrmAgencyProvider(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		disconnectCrmAgencyProvider: d,
		disconnectCrmAgencyProviderPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Q = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.exportCrmNetworkItemizedTransactions(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		exportCrmNetworkItemizedTransactions: d,
		exportCrmNetworkItemizedTransactionsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ne = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmActiveListingsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmActiveListingsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmActiveListingsForAgency", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmAgencyConnectionDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmAgencyConnectionDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmAgencyConnectionDetails", ...n] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmAgencyListingsPermanentLinkModel", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmAgencyListingsPermanentLinkModel(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmAgencyListingsPermanentLinkModel", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ce = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(K), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmAgentDetails",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== t || i[5] !== s ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmAgentDetails(e, t, r);
	}, i[3] = e, i[4] = t, i[5] = s, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, le = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmAgentDetails", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ue = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmContractCommissionDiscrepancies", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmContractCommissionDiscrepancies(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, de = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmContractCommissionDiscrepancies", ...n] });
	}, e[0] = t, e[1] = n), n;
}, fe = (e, t, n, i) => {
	let a = r(19), s = i === void 0 || i, c = o(K), l;
	a[0] !== e || a[1] !== t || a[2] !== n ? (l = [
		"getCrmCurrentPartnershipInformation",
		e,
		t,
		n
	], a[0] = e, a[1] = t, a[2] = n, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== e || a[5] !== t || a[6] !== c || a[7] !== n ? (f = (r) => {
		let { signal: i } = r;
		return c.getCrmCurrentPartnershipInformation(e, t, n, i);
	}, a[4] = e, a[5] = t, a[6] = c, a[7] = n, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _, error: v, isFetching: y } = u(m), b;
	return a[13] !== h || a[14] !== v || a[15] !== _ || a[16] !== y || a[17] !== g ? (b = {
		data: h,
		isPending: g,
		isError: _,
		error: v,
		isFetching: y
	}, a[13] = h, a[14] = v, a[15] = _, a[16] = y, a[17] = g, a[18] = b) : b = a[18], b;
}, pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmCurrentPartnershipInformation", ...n] });
	}, e[0] = t, e[1] = n), n;
}, me = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmEntityNumbers(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmEntityNumbers: d,
		getCrmEntityNumbersPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, he = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmExecutiveKeyMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmExecutiveKeyMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmExecutiveKeyMetrics", ...n] });
	}, e[0] = t, e[1] = n), n;
}, _e = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmExecutiveRunRateMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmExecutiveRunRateMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmExecutiveRunRateMetrics", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ye = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmLeaderboardStatisticsForEntity(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmLeaderboardStatisticsForEntity: d,
		getCrmLeaderboardStatisticsForEntityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, be = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(K), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmListingByCampaignId",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmListingByCampaignId(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, xe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmListingByCampaignId", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Se = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmListingDiscrepancies", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmListingDiscrepancies(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, Ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmListingDiscrepancies", ...n] });
	}, e[0] = t, e[1] = n), n;
}, we = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmNetworkPartnershipMetrics(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmNetworkPartnershipMetrics: d,
		getCrmNetworkPartnershipMetricsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Te = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmNetworkStateMetrics(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmNetworkStateMetrics: d,
		getCrmNetworkStateMetricsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ee = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmPartnershipInformation(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmPartnershipInformation: d,
		getCrmPartnershipInformationPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, De = (e, t, n) => {
	let i = r(17), a = n === void 0 || n, s = o(K), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getCrmPublishedListingDetail",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getCrmPublishedListingDetail(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g, error: _, isFetching: v } = u(p), y;
	return i[11] !== m || i[12] !== _ || i[13] !== g || i[14] !== v || i[15] !== h ? (y = {
		data: m,
		isPending: h,
		isError: g,
		error: _,
		isFetching: v
	}, i[11] = m, i[12] = _, i[13] = g, i[14] = v, i[15] = h, i[16] = y) : y = i[16], y;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmPublishedListingDetail", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Oe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmPublishedListingDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmPublishedListingDetails: d,
		getCrmPublishedListingDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ke = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmPublishedListingsAgentsAndSuburbs", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmPublishedListingsAgentsAndSuburbs(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, Ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmPublishedListingsAgentsAndSuburbs", ...n] });
	}, e[0] = t, e[1] = n), n;
}, je = (e, t, n, i, a, s) => {
	let c = r(23), l = s === void 0 || s, d = o(K), f;
	c[0] !== n || c[1] !== e || c[2] !== i || c[3] !== t || c[4] !== a ? (f = [
		"getCrmStaffLeaderboardStatistics",
		e,
		t,
		n,
		i,
		a
	], c[0] = n, c[1] = e, c[2] = i, c[3] = t, c[4] = a, c[5] = f) : f = c[5];
	let p = f, m;
	c[6] !== d || c[7] !== n || c[8] !== e || c[9] !== i || c[10] !== t || c[11] !== a ? (m = (r) => {
		let { signal: o } = r;
		return d.getCrmStaffLeaderboardStatistics(e, t, n, i, a, o);
	}, c[6] = d, c[7] = n, c[8] = e, c[9] = i, c[10] = t, c[11] = a, c[12] = m) : m = c[12];
	let h = l && !!d, g;
	c[13] !== p || c[14] !== m || c[15] !== h ? (g = {
		queryKey: p,
		queryFn: m,
		enabled: h
	}, c[13] = p, c[14] = m, c[15] = h, c[16] = g) : g = c[16];
	let { data: _, isPending: v, isError: y, error: b, isFetching: x } = u(g), S;
	return c[17] !== _ || c[18] !== b || c[19] !== y || c[20] !== x || c[21] !== v ? (S = {
		data: _,
		isPending: v,
		isError: y,
		error: b,
		isFetching: x
	}, c[17] = _, c[18] = b, c[19] = y, c[20] = x, c[21] = v, c[22] = S) : S = c[22], S;
}, Me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmStaffLeaderboardStatistics", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Ne = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmStatisticsForEntity(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmStatisticsForEntity: d,
		getCrmStatisticsForEntityPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Pe = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getCrmSuburbs(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getCrmSuburbs: d,
		getCrmSuburbsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Fe = (e) => {
	let t = r(12), n = e === void 0 || e, i = o(K), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getCrmTopPerformers"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getCrmTopPerformers(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p, error: m, isFetching: h } = u(l), g;
	return t[6] !== d || t[7] !== m || t[8] !== p || t[9] !== h || t[10] !== f ? (g = {
		data: d,
		isPending: f,
		isError: p,
		error: m,
		isFetching: h
	}, t[6] = d, t[7] = m, t[8] = p, t[9] = h, t[10] = f, t[11] = g) : g = t[11], g;
}, Ie = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmTopPerformers", ...n] });
	}, e[0] = t, e[1] = n), n;
}, Le = (e, t) => {
	let n = r(15), i = t === void 0 || t, a = o(K), s;
	n[0] === e ? s = n[1] : (s = ["getCrmUpcomingSettlementsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCrmUpcomingSettlementsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h, error: g, isFetching: _ } = u(f), v;
	return n[9] !== p || n[10] !== g || n[11] !== h || n[12] !== _ || n[13] !== m ? (v = {
		data: p,
		isPending: m,
		isError: h,
		error: g,
		isFetching: _
	}, n[9] = p, n[10] = g, n[11] = h, n[12] = _, n[13] = m, n[14] = v) : v = n[14], v;
}, Re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (...e) => {
		let n = e;
		for (; n.length > 0 && n[n.length - 1] === void 0;) n.pop();
		await t.invalidateQueries({ queryKey: ["getCrmUpcomingSettlementsForAgency", ...n] });
	}, e[0] = t, e[1] = n), n;
}, ze = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setCrmListingPublishedToPortal(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setCrmListingPublishedToPortal: d,
		setCrmListingPublishedToPortalPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Be = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(K), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateCrmAgentDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateCrmAgentDetails: d,
		updateCrmAgentDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { m as ContractDateToUse, h as CrmAgencyConnectionCapabilityResponseConnectionManagement, g as CrmAgencyConnectionCapabilityResponseInvoices, _ as CrmAgencyConnectionCapabilityResponseListingRead, v as CrmAgencyConnectionCapabilityResponseListingWrite, y as CrmAgencyConnectionCapabilityResponseReporting, b as CrmAgencyConnectionCapabilityResponseTrustAccounting, x as CrmAgencyConnectionCapabilityResponseWebhooks, S as CrmAgencyConnectionProviderResponseStatus, C as CrmAgencyProviderConnectionResponseStatus, K as CrmApiContext, z as CrmApiException, q as CrmApiProvider, p as CrmClient, w as CrmCurrentReviewPeriodPartnershipInformationPartnershipLevel, T as CrmExecutiveMetricsResponseContractType, E as CrmKeyMetricMetricType, D as CrmListingDetailsRequestListingState, ee as CrmListingDetailsRequestSortingType, te as CrmListingLinkLinkType, O as CrmPartnershipInformationPartnershipLevel, k as CrmProviderDiagnosticResponseSeverity, A as CrmPublishedListingModelListingState, j as CrmPublishedListingModelOverridenListingStatus, M as CrmResultMetadataProviderKind, N as CrmResultMetadataStatus, V as CrmRoute, P as CrmRunRateMetricMetricType, F as EntityType, I as JsonElementValueKind, L as Provider, R as TimePeriod, J as useConnectCrmAgencyProvider, Y as useCreateCrmLead, G as useCrmClientContext, X as useCrmProviderWebhook, Z as useDisconnectCrmAgencyProvider, Q as useExportCrmNetworkItemizedTransactions, ne as useGetCrmActiveListingsForAgency, ie as useGetCrmAgencyConnectionDetails, oe as useGetCrmAgencyListingsPermanentLinkModel, ce as useGetCrmAgentDetails, ue as useGetCrmContractCommissionDiscrepancies, fe as useGetCrmCurrentPartnershipInformation, me as useGetCrmEntityNumbers, he as useGetCrmExecutiveKeyMetrics, _e as useGetCrmExecutiveRunRateMetrics, ye as useGetCrmLeaderboardStatisticsForEntity, be as useGetCrmListingByCampaignId, Se as useGetCrmListingDiscrepancies, we as useGetCrmNetworkPartnershipMetrics, Te as useGetCrmNetworkStateMetrics, Ee as useGetCrmPartnershipInformation, De as useGetCrmPublishedListingDetail, Oe as useGetCrmPublishedListingDetails, ke as useGetCrmPublishedListingsAgentsAndSuburbs, je as useGetCrmStaffLeaderboardStatistics, Ne as useGetCrmStatisticsForEntity, Pe as useGetCrmSuburbs, Fe as useGetCrmTopPerformers, Le as useGetCrmUpcomingSettlementsForAgency, re as useInvalidateUseGetCrmActiveListingsForAgency, ae as useInvalidateUseGetCrmAgencyConnectionDetails, se as useInvalidateUseGetCrmAgencyListingsPermanentLinkModel, le as useInvalidateUseGetCrmAgentDetails, de as useInvalidateUseGetCrmContractCommissionDiscrepancies, pe as useInvalidateUseGetCrmCurrentPartnershipInformation, ge as useInvalidateUseGetCrmExecutiveKeyMetrics, ve as useInvalidateUseGetCrmExecutiveRunRateMetrics, xe as useInvalidateUseGetCrmListingByCampaignId, Ce as useInvalidateUseGetCrmListingDiscrepancies, $ as useInvalidateUseGetCrmPublishedListingDetail, Ae as useInvalidateUseGetCrmPublishedListingsAgentsAndSuburbs, Me as useInvalidateUseGetCrmStaffLeaderboardStatistics, Ie as useInvalidateUseGetCrmTopPerformers, Re as useInvalidateUseGetCrmUpcomingSettlementsForAgency, ze as useSetCrmListingPublishedToPortal, Be as useUpdateCrmAgentDetails };
